var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 8.73478 0.105357 8.48043 0.292893 8.29289C0.48043 8.10536 0.734784 8 1 8H13C13.7956 8 14.5587 7.68393 15.1213 7.12132C15.6839 6.55871 16 5.79565 16 5V1C16 0.734784 16.1054 0.48043 16.2929 0.292893C16.4804 0.105357 16.7348 0 17 0C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V5C18 6.32608 17.4732 7.59785 16.5355 8.53553C15.5979 9.47322 14.3261 10 13 10H1C0.734784 10 0.48043 9.89464 0.292893 9.70711C0.105357 9.51957 0 9.26522 0 9Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.293031 9.70698C0.105559 9.51945 0.000244141 9.26514 0.000244141 8.99998C0.000244141 8.73482 0.105559 8.48051 0.293031 8.29298L4.29303 4.29298C4.48163 4.11082 4.73423 4.01003 4.99643 4.01231C5.25863 4.01458 5.50944 4.11975 5.69485 4.30516C5.88026 4.49057 5.98543 4.74138 5.9877 5.00358C5.98998 5.26578 5.88919 5.51838 5.70703 5.70698L2.41403 8.99998L5.70703 12.293C5.80254 12.3852 5.87872 12.4956 5.93113 12.6176C5.98354 12.7396 6.01113 12.8708 6.01228 13.0036C6.01344 13.1364 5.98813 13.268 5.93785 13.3909C5.88757 13.5138 5.81332 13.6255 5.71943 13.7194C5.62553 13.8133 5.51388 13.8875 5.39098 13.9378C5.26809 13.9881 5.13641 14.0134 5.00363 14.0122C4.87085 14.0111 4.73963 13.9835 4.61763 13.9311C4.49562 13.8787 4.38528 13.8025 4.29303 13.707L0.293031 9.70698Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyicon);
export default __webpack_public_path__ + "static/media/reply icon.1037f146d1bddcd5ba7e1641388b2df1.svg";
export { ForwardRef as ReactComponent };